// 系统管理
const user = [
  {
    path: '/user',
    name: 'userPage',
    meta: { tag: '系统后台用户' },
    component: () => import('@/pages/user/UserPage')
  },
  {
    path: '/factory-users',
    name: 'factory-users',
    meta: { tag: '工厂端用户' },
    component: () => import('@/pages/FactoryUserPage')
  },
  {
    path: '/warehouse-users',
    name: 'warehouse-users',
    meta: { tag: '中转仓用户' },
    component: () => import('@/pages/WarehouseUserPage')
  },
  {
    path: '/customers',
    name: 'customers',
    meta: { tag: '客户记录' },
    component: () => import('@/pages/CustomerPage')
  },
  {
    path: '/foreign-users',
    name: 'foreign-users',
    meta: { tag: '国外授权点用户' },
    component: () => import('@/pages/ForeignUserPage')
  },
  {
    path: '/group',
    name: 'group',
    meta: { tag: '群组' },
    component: () => import('@/pages/GroupPage')
  },
  {
    path: '/roles',
    name: 'roles',
    meta: { tag: '角色' },
    component: () => import('@/pages/role/Roles')
  },
  {
    path: '/rolePermission',
    name: 'rolePermission',
    meta: { tag: '角色权限' },
    component: () => import('@/pages/role/RolePermission')
  },
  {
    path: '/permission',
    name: 'permission',
    meta: { tag: '权限' },
    component: () => import('@/pages/permission/Permissions')
  },
  {
    path: '/assignPermission',
    name: 'assignPermission',
    meta: { tag: '权限配置' },
    component: () => import('@/pages/permission/AssignPermission')
  },
  {
    path: '/routes',
    name: 'routePage',
    meta: { tag: '路由' },
    component: () => import('@/pages/RoutePage')
  },
  {
    path: '/assignment',
    name: 'assignmentPage',
    meta: { tag: '用户分配' },
    component: () => import('@/pages/user/AssignmentPage')
  },
]

export default user
